export default {
      id: "nav_pause-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#nav_pause-usage",
      toString: function () {
        return this.url;
      }
    }